import styled from 'styled-components/macro';
import { defaultContainer } from '../../styles/utils';

export const AccountDiv = styled.div`
  ${defaultContainer}
`;

export const AccountHeaderDiv = styled.div`
  padding-top: 5rem;
  margin-bottom: 3rem;
  @media screen and (max-width: 767px) {
    margin-left: -2rem;
  }
`;
